import styles from 'styles/views/widgets/Button.css';
import React, { PropTypes } from 'react';
import classnames from 'classnames';

const Button = ({ disabled, onClick, style, children, className, ...props }) => (
  <button
    className={classnames(styles.button,
                {[className]: className, [styles.button_disabled]: disabled})}
    onClick={onClick}
    disabled={disabled || false}
    style={style || {}}
    {...props}>
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  disabled: PropTypes.bool
};

export default Button;



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Button.js
 **/